/**
 * Created by yoavp on 12/30/2014.
 */

define(function (require) {
    "use strict";

    var TabsModel = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {
        TabsModel = Backbone.Model.extend({
            name: "TabsModel",
            defaults: {
                chatNotificationsCounter: 0,
                notificationCenterEventsCounter: 0,
                newKPsCounter: 0,
                chatIsActive: false,
                handleMinimized: true
            }
        });
    });
    return TabsModel;
});
